<!-- ***************************************************************************************************************************** -->
<!-- Form Div for Success Metrics/Student Profile -->
<tool-form formTitle="Trend Filters">
  <form
    [formGroup]="aprGraduationSummaryForm"
    (ngSubmit)="aprGraduationSummarySubmit()"
    class="form-content"
  >
    <!-- College Input -->
    <mat-form-field class="filter-form-field" appearance="fill">
      <mat-label>Select a College</mat-label>
      <mat-select
        formControlName="college"
        (selectionChange)="onCollegeChange()"
      >
        <mat-option value="" selected>All</mat-option>
        <mat-option *ngFor="let college of filters.colleges" [value]="college">
          {{ college }}</mat-option
        >
      </mat-select>
    </mat-form-field>

    <!-- Department Input -->
    <mat-form-field class="filter-form-field" appearance="fill">
      <mat-label>Select a Department</mat-label>
      <mat-select
        formControlName="department"
        (selectionChange)="onDepartmentChange()"
      >
        <mat-option value="" selected>All</mat-option>
        <mat-option
          *ngFor="let department of filters.departments"
          [value]="department.name"
        >
          {{ department.name }}</mat-option
        >
      </mat-select>
    </mat-form-field>

    <!-- Program Input -->
    <mat-form-field class="filter-form-field" appearance="fill">
      <mat-label>Select a Program</mat-label>
      <mat-select formControlName="program">
        <mat-option value="" selected>All</mat-option>
        <mat-option
          *ngFor="let program of filters.programs"
          [value]="program.name"
        >
          {{ program.name }}</mat-option
        >
      </mat-select>
    </mat-form-field>

    <!-- Cohort Input -->
    <mat-form-field class="filter-form-field" appearance="fill">
      <mat-label>Select a Cohort</mat-label>
      <mat-select formControlName="cohort">
        <mat-option *ngFor="let cohort of filters.cohorts" [value]="cohort">
          {{ cohort }}</mat-option
        >
      </mat-select>
    </mat-form-field>

    <!-- High School GPA Input -->
    <div class="form-slider-container">
      <mat-label class="form-slider-text-label">High School GPA</mat-label>
      <mat-slider class="form-slider" min="0" max="5.04" step="0.25">
        <input
          value="0"
          matSliderStartThumb
          #sliderStartHS
          formControlName="hs_gpa_lower"
        />
        <input
          value="5.04"
          matSliderEndThumb
          #sliderEndHS
          formControlName="hs_gpa_upper"
        />
      </mat-slider>
      <div class="form-slider-value-label-container">
        <label class="example-value-label">{{ sliderStartHS.value }}</label>
        <label class="example-value-label">{{ sliderEndHS.value }}</label>
      </div>
    </div>

    <!-- Demographic Input -->
    <mat-form-field class="filter-form-field" appearance="fill">
      <mat-label>Select a Demographic</mat-label>
      <mat-select formControlName="demographic">
        <mat-option value="" selected>None</mat-option>
        <mat-option
          *ngFor="let demographic of filters.demographics"
          [value]="demographic"
        >
          {{ demographic }}</mat-option
        >
      </mat-select>
    </mat-form-field>

    <!-- Submit Button -->
    <tool-form-action-button
      text="Submit"
      (onClick)="closeDialog()"
    ></tool-form-action-button>
  </form>
</tool-form>
